var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getCookie, setCookie } from "@common/cookie/cookie";
export var FAVORITES_COOKIE_NAME = "ucn-favorites";
var COOKIE_OPTIONS = {
    path: "/",
    sameSite: "strict",
    secure: true,
    expires: 500,
};
var get = function () {
    var favorites = getCookie(FAVORITES_COOKIE_NAME);
    if (!favorites)
        return { collection: [] };
    return favorites;
};
var has = function (id, favorites) { var _a; return (_a = favorites === null || favorites === void 0 ? void 0 : favorites.collection) === null || _a === void 0 ? void 0 : _a.includes(id); };
var set = function (id, favorites) {
    var collection = __spreadArray(__spreadArray([], __read(((favorites === null || favorites === void 0 ? void 0 : favorites.collection) ? favorites.collection : [])), false), [
        id,
    ], false);
    setCookie(FAVORITES_COOKIE_NAME, JSON.stringify({ collection: collection }), COOKIE_OPTIONS);
    return { collection: collection };
};
var remove = function (id, favorites) {
    var collection = favorites.collection.filter(function (value) { return value !== id; });
    setCookie(FAVORITES_COOKIE_NAME, JSON.stringify({ collection: collection }), COOKIE_OPTIONS);
    return { collection: collection };
};
export var favoriteCookieService = { get: get, set: set, remove: remove, has: has };
